import {useQuery, gql} from "@apollo/client";
var  HOME_SLIDE_SHOW_LIST = gql`
query HomeSlideShowList {
  homeSlideShow( where: {localization: {culture_starts_with: "fa"}}) {
    bag {
      contentItems {
        ... on HomeSlidePicture {
          id
          slideImage {
            urls(first: 1)
          }
          displayText
          buttonLink {
            text
            url
          }
          description
        }
        displayText
      }
    }
    displayText
  }
}
`;

export const useHomeSlideShow = () => {
  const {error, loading, data} = useQuery(HOME_SLIDE_SHOW_LIST);
  return {
    error, data, loading
  };
  } 